/**
 *  @class
 *  @function ThemeFooter
 */

if (!customElements.get('theme-footer')) {
  class ThemeFooter extends HTMLElement {
    constructor() {
      super();
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.accordions = this.querySelectorAll('details');
      this.previousIsDesktop = window.innerWidth > 768;

      // Preserve the existing default state only during initial render.
      this.setInitialAccordionState();

      // Add resize event listener
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      // Remove resize event listener when element is removed
      window.removeEventListener('resize', this.onResize);
    }

    onResize() {
      const isDesktop = window.innerWidth > 768;

      if (this.previousIsDesktop === isDesktop) return;

      this.previousIsDesktop = isDesktop;

      if (isDesktop) {
        this.accordions.forEach((accordion) => {
          accordion.setAttribute('open', '');
        });
      }
    }

    setInitialAccordionState() {
      this.accordions.forEach((accordion) => {
        if (this.previousIsDesktop) {
          accordion.setAttribute('open', '');
        } else {
          accordion.removeAttribute('open');
        }
      });
    }
  }

  customElements.define('theme-footer', ThemeFooter);
}
